import { render } from "./CommunicationList.vue?vue&type=template&id=09679662&ts=true"
import script from "./CommunicationList.vue?vue&type=script&lang=ts"
export * from "./CommunicationList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__